export class InvalidJsonError extends Error {
  constructor() {
    super(`InvalidJsonError`);
  }
}

/** This code parses a JSON string and returns the resulting object. */
export const safeJsonParse = <T = unknown>(json: string | undefined, shouldThrow: boolean = true): T | null => {
  if (!json) {
    if (shouldThrow) {
      throw new InvalidJsonError();
    }
    return null;
  }
  try {
    return JSON.parse(json) as T;
  } catch {
    if (shouldThrow) {
      throw new InvalidJsonError();
    }
    return null;
  }
};
